<template>
  <div class="live-intro" :class="{ ishome: isHome }" v-show="isShow">
    <div class="introduce-left">
      <div class="intro-top">
        <div class="live-icon">
          <i class="iconfont living-icon">&#xe60b;</i>&ensp;{{
            $t("introduceLive.live_recommend")
          }}
        </div>
        <div class="gaming-list">
          <div
            class="game-name"
            v-for="(item, index) in navList"
            :key="item.id"
            :class="{ active: gameTypeIndex == index }"
            @click="chooseSportType(item, index)"
          >
            {{ $t("introduceLive." + item.name) || item.name }}
          </div>
        </div>
      </div>
      <div class="intro-bottom">
        <template v-if="!livingList.length && !livingList.loaded">
          <div
            class="intro-list"
            v-for="(item, index) in new Array(8).fill(0)"
            :key="index"
          >
            <Skeleton :column="2" />
          </div>
        </template>
        <template v-else>
          <router-link
            target="_blank"
            :to="'/liveDetails/' + item.uid + '-' + item.stream"
            class="intro-list"
            v-for="item in livingList"
            :key="item.uid"
            @click.native="keepLivePull(item.pull)"
          >
            <div class="introlist-top">
              <img class="living" src="../assets/img/living.gif" alt="" />
              <img v-lazy="item.thumb" :alt="$t('introduceLive.icon_alt')" />
              <div class="hover-play">
                <span></span>
              </div>
            </div>
            <div class="introlist-bottom">
              <div class="introlist-words">
                {{ item.title }}
              </div>
              <div class="introlist-look">
                <div class="look-left">
                  <img
                    v-lazy="item.avatar_thumb || item.user.avatar_thumb"
                    :alt="$t('introduceLive.icon_alt')"
                  />
                  &ensp;{{ item.user_nicename || item.user.user_nicename }}
                </div>
                <div class="look-right">
                  <i class="iconfont look-time">&#xe607;</i>&ensp;{{
                    item.viewnum || item.user.viewnum
                  }}
                </div>
              </div>
            </div>
          </router-link>
        </template>
      </div>
      <no-data v-show="!livingList.length && livingList.loaded" />
    </div>
    <living-rank :isHome="isHome" />
  </div>
</template>

<script>
import noData from "./../base/noData";
import livingRank from "./livingRank";
import { mapState } from "vuex";
import { apiGetHot, apiToAttent, liveSportsPcList } from "../http";
export default {
  name: "introduceLive",
  components: {
    livingRank,
    noData,
  },
  props: ["isHome", "liveuid"],
  data() {
    return {
      isShow: true,
      livingList: [],
      // gameType: ['全部','足球', '篮球', '电竞','其他'],
      gameTypeIndex: "0",
    };
  },
  computed: {
    ...mapState(["sportType"]),
    navList() {
      // 推荐、足球、篮球、电竞、其他等
      return [
        {
          name: "recommend",
          id: 0,
        },
        ...this.sportType,
      ];
    },
  },
  mounted() {
    // this.livingSports();
    this.getRecommendLive();
  },
  methods: {
    keepLivePull(pull) {
      //点击推荐直播列表进入直播间
      localStorage.setItem("pull", pull);
      this.$emit("keepNewPull", pull);
    },
    // livingSports(sort){//获取体育推荐直播列表
    //   liveSportsPcList({limit: 12,page:1,class_id:sort})
    //     .then(res => {
    //       if(this.gameTypeIndex == 0 && sort){
    //         return;
    //       }else if(this.gameTypeIndex == 1 && sort != 4){
    //         return;
    //       }else if(this.gameTypeIndex == 2 && sort != 2){
    //         return;
    //       }else if(this.gameTypeIndex == 3 && sort != 3){
    //         return;
    //       };
    //       if(res.status == 200){
    //         if(JSON.stringify(res.data) == '[]'){
    //           this.livingList = [];
    //           this.livingList.loaded = true;
    //           return;
    //         }
    //         let resInfo = res.data.data;
    //         if(this.$route.name == 'liveDetails'){
    //           let arr = this.$route.params.id.split('-');
    //           let resL = resInfo.length;
    //           for(let i = 0;i < resL;i ++){
    //             if(arr[0] == resInfo[i].uid){
    //               resInfo.splice(i,1);
    //               break;
    //             }
    //           }
    //         }
    //         // resInfo.splice(8);
    //         this.livingList = resInfo;
    //         this.livingList.loaded = true;
    //         if(this.gameTypeIndex === '0'){
    //           this.$emit('introLive',this.livingList);
    //         }
    //       }
    //     })
    // },
    // 关注
    toAttent(item) {
      apiToAttent({ touid: item.uid }).then((res) => {
        item.attention = res.info[0].isattent;
      });
    },
    getRecommendLive() {
      this.livingList.loaded = true;
      this.$axios
        .post("api/", {
          service: "Home.GetHot",
        })
        .then((response) => {
          this.livingList.loaded = false;
          let res = response.data.data;
          if (res.code == 0 && response.status == 200) {
            this.livingList = res.info;
            // Store.save("banRecommendLive", response.data.data.info);
          } else {
            this.livingList.loaded = false;
            // this.$toast.text(res.msg);
          }
        })
        .catch((error) => {
          // this.$toast.text(error);
          // `${error.message}`
        });
    },
    fetchList(id) {
      this.$axios
        .post("api/", {
          service: "Home.GetClassLive",
          liveclassid: id,
        })
        .then((res) => {
          let data = res.data.data;
          if (data.code === 0) {
            this.livingList = data.info;
            this.livingList.loaded = true;
          } else {
            this.livingList.loaded = false;
          }
        })
        .catch((err) => {});
    },
    chooseSportType(item, index) {
      this.gameTypeIndex = index;
      if (index === 0) {
        this.getRecommendLive();
      } else {
        this.fetchList(item.id);
      }
    },
  },
  watch: {
    // gameTypeIndex(newIndex,oldIndex){
    //   this.livingList = [];
    //   if(newIndex == 0){//全部
    //     this.livingSports();
    //   }else if(newIndex == 1){//足球
    //     this.livingSports(4);
    //   }else if(newIndex == 2){//篮球
    //     this.livingSports(2);
    //   }else if(newIndex == 3){//电竞
    //     this.livingSports(3);
    //   }else if(newIndex == 4){//其他
    //     this.livingSports(6);
    //   }
    // }
  },
};
</script>

<style scoped>
.live-intro {
  padding: 2rem 0;
  display: flex;
  justify-content: space-between;
  color: #2c2727;
}
.introduce-left {
  display: flex;
  flex-direction: column;
  width: 108.5rem;
}
.intro-top {
  display: flex;
}
.live-icon {
  font-size: 2.4rem;
  font-weight: bold;
}
.living-icon,
.living-management {
  color: var(--primary-color);
  font-size: 3rem;
}
.gaming-list {
  width: 75rem;
  font-size: 1.4rem;
  /* margin-left: 4rem; */
  display: flex;
  align-items: center;
  overflow-x: scroll;
}
.game-name {
  padding: 0 1.5rem;
  cursor: pointer;
  user-select: none;
}
.game-name:hover,
.game-name.active {
  font-weight: bold;
  color: var(--primary-color);
}
.intro-bottom {
  margin-top: 1.7rem;
  background: #fff;
  padding-top: 1.2rem;
  /* display:flex; */
  /* justify-content: space-around; */
  flex-wrap: wrap;
  flex: 1;
}
.intro-bottom .intro-list {
  float: left;
  margin-left: 1.5rem;
}
.intro-list {
  width: 25rem;
  box-shadow: 0 0 0.1rem #000;
  margin-bottom: 2.1rem;
  cursor: pointer;
}
.introlist-top {
  width: 25rem;
  height: 12.3rem;
  overflow: hidden;
  position: relative;
}
.ishome .intro-list {
  width: 22rem;
}
.ishome .introlist-top {
  width: 22rem;
}
.ishome .introduce-left {
  width: 95.3rem;
}
.ishome .introduce-right {
  width: 24rem;
}
.introlist-top .living {
  width: 48px;
  position: absolute;
  top: 5px;
  right: 5px;
  height: 19.9px;
  border-radius: 4px;
}
.intro-list:hover .hover-play,
.intro-list:hover .introlist-words {
  display: block;
  color: var(--primary-color);
}
.hover-play {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
}
.hover-play span {
  width: 5rem;
  height: 5rem;
  position: absolute;
  left: 50%;
  margin-left: -2.5rem;
  top: 50%;
  margin-top: -2.5rem;
  background: url("./../assets/img/hover-play.png") center center;
  background-size: 100% 100%;
}
.introlist-top img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.introlist-bottom {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}
.introlist-words {
  font-weight: bold;
  min-height: 1.4rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #2b2626;
}
.introlist-look {
  margin-top: 1.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.look-left,
.look-right {
  color: #949292;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.look-right {
  min-width: 7rem;
  text-align: right;
}
.look-left img {
  width: 2.7rem;
  height: 2.7rem;
  object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
}
img {
  background: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// src/base/introduceLive.vue